var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('div',{staticClass:"pb-40 h-full"},[_c('div',{staticClass:"w-full h-screen bg-center bg-cover",style:(("background-image: url(" + (_vm.getAssetUrl('resource_' + _vm.settings.value.id)) + ")"))})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }